import clsx from "clsx";

export const BaseInput = ({
  type = "text",
  placeholder,
  label,
  className,
  inputClass,
  leadingIcon,
  value,
  onChange,
  ...props
}) => {
  return (
    <div className={clsx("relative", className)}>
      <label className="text-sm text-primary-black mb-3.5 inline-block">
        {label}
      </label>
      {leadingIcon}
      <input
        type={type}
        placeholder={placeholder}
        value={value}
        onChange={onChange}
        className={clsx("base_input", inputClass)}
        {...props}
      />
    </div>
  );
};
